module.exports = ".fw-600{\n    font-weight: 600;\n}\n"